import { Box, Grid, Paper, Typography } from '@mui/material';

import React from 'react';
import {
  AppFormikCheckbox,
  AppFormikSelectWithKeys,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

const IdentityAuthenticationAndAccessControl: React.FC<any> = (props) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { purpose } = props;
  console.log(purpose);
  return (
    <Box className="paper-form-content">
      <Paper variant="outlined">
        <Typography variant="h6">
          Identity, Authentication & Access Control
        </Typography>
        <Box className="paper-form-input-content">
          <Grid spacing={4} container className="paper-form-label-input-grid">
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="auth_method"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="auth_method-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select..."
                notEmphasized
                notSelectablePlaceholder
                label="Authentication Method"
                titleKey="title"
                valueKey="value"
                items={[
                  { title: 'OAuth', value: 'OAuth' },
                  { title: 'API Key', value: 'API key' },
                  { title: 'Service Account', value: 'service account' },
                  { title: 'mTLS', value: 'mTLS' },
                ]}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="identity_provider"
                placeholder="Enter identity provider"
                outerLabel
                label="Identity Provider"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="authorization_model"
                className="rework-selection"
                notched={false}
                labelId="fix-selection-label"
                testid="authorization_model-dropdown"
                MenuProps={{
                  className: 'menu-fix-selection single-fix-rework',
                }}
                outerLabel
                placeholder="Select..."
                notEmphasized
                notSelectablePlaceholder
                label="Authorization Model"
                titleKey="title"
                valueKey="value"
                items={[
                  { title: 'RBAC', value: 'RBAC' },
                  { title: 'ABAC', value: 'ABAC' },
                  { title: 'Scoped Tokens', value: 'scoped tokens' },
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="required_roles_permissions"
                placeholder="Enter required roles permissions"
                label="Required Roles/Permissions"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12} sx={{ alignContent: 'center' }}>
              <AppFormikCheckbox
                name="least_privilege_available"
                label="Least Privilege Profile Available"
                outerLabel=""
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikSelectWithKeys
                name="human_vs_machine_access"
                notched={false}
                outerLabel
                placeholder="Select..."
                notEmphasized
                notSelectablePlaceholder
                label="Human vs Machine Access"
                titleKey="title"
                valueKey="value"
                items={[
                  { title: 'Human', value: 'Human' },
                  { title: 'Machine', value: 'Machine' },
                  { title: 'Both', value: 'Both' },
                ]}
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="secrets_management_approach"
                placeholder="Enter secrets management approach"
                label="Secrets Management Approach"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <AppFormikTextField
                name="token_lifetime_rotation"
                placeholder="Enter token lifetime rotation"
                outerLabel
                label="Token Lifetime & Rotation Policy"
              />
            </Grid>
            <Grid item md={6} xs={12} sx={{ alignContent: 'center' }}>
              <AppFormikCheckbox
                name="tenant_isolation_support"
                label="Tenant Isolation Support"
                outerLabel=""
              />
            </Grid>
            <Grid item xs={12}>
              <AppFormikTextArea
                name="break_glass_details"
                placeholder="Enter break glass details"
                label="Break-Glass / Admin Override Details"
                outerLabel
                rows={3}
                inputProps={{
                  style: { resize: 'vertical' },
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default IdentityAuthenticationAndAccessControl;
